import { Alert, Box, Card, CardContent, Typography } from '@mui/material';
import { t } from 'i18next';

type Props = {
  section?: boolean;
};

export const HiddenIssues = ({ section = false }: Props) => {
  if (!section) {
    return (
      <Alert severity="info" sx={{ my: 2 }}>
        {t('exportHiddenIssues')}
      </Alert>
    );
  }
  return (
    <Card>
      <CardContent>
        <Box>
          <Box sx={{ backgroundColor: 'grey.100', px: 2, py: 2, borderRadius: '4px' }}>
            <Typography fontWeight="bold">{t('priorityIssues')}</Typography>
          </Box>
          <Alert severity="info" sx={{ mt: 2 }}>
            {t('exportOnlyHiddenIssues')}
          </Alert>
        </Box>
      </CardContent>
    </Card>
  );
};
